import React from 'react';
import { Link } from 'react-router-dom';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import ethitechImage from '../assets/images/projectimages/ethitech.png';
import greenevilleDeliImage from '../assets/images/projectimages/greeneville-deli.png';
import worldAppImage from '../assets/images/projectimages/world-app.png';
import medicalImage from '../assets/images/projectimages/gallaghermedical.png';
import projectsJSON from '../data/projects.json';

const imageMap = {
    "ethitech.png": ethitechImage,
    "greeneville-deli.png": greenevilleDeliImage,
    "world-app.png": worldAppImage,
    "gallaghermedical.png": medicalImage
};

const responsive = {
    superLargeDesktop: {
        breakpoint: { max: 4000, min: 3000 },
        items: 5
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1
    }
};

const ProjectCarousel = () => {
    return (
        <Carousel responsive={responsive}
                           autoPlay={true}
                           autoPlaySpeed={2500}
                           infinite={true}>
            {projectsJSON.map((project, index) => (
                <div key={index} className="p-4">
                    <Link to={`/projects/${project.slug}`}>
                    <img src={imageMap[project.images[0].url]} alt={project.images[0].caption} className="w-full h-48 object-cover rounded-lg" />
                    <h1 className="text-2xl font-semibold mt-2">{project.title}</h1>
                    </Link>
                </div>
            ))}
        </Carousel>
    );
};

export default ProjectCarousel;